import React, { useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useSearchMunicipalitiesQuery } from '../../store/api/municipalityApi';

const MunicipalitySearch = ({ onMunicipalitySelect, onInputChange }) => {
  const [query, setQuery] = useState('');
  const { data: municipalities, isLoading } = useSearchMunicipalitiesQuery(query, {
    skip: query.length < 2,
  });

  const handleSelection = (event, value) => {
    if (value) {
      onMunicipalitySelect({ ...value, code: value.municipalityCode });
    } else {
      onMunicipalitySelect(null);
    }
  };

  return (
    <Autocomplete
      sx={{ width: { xs: 200, sm: 300 }, backgroundColor: 'white', borderRadius: 1 }}
      options={municipalities || []}
      getOptionLabel={(option) => option.municipality}
      loading={isLoading}
      onChange={handleSelection}
      onInputChange={(event, newInputValue) => {
        setQuery(newInputValue);
        if (onInputChange) {
          onInputChange();
        }
        if (newInputValue === '') {
          onMunicipalitySelect(null);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Търсене на община"
          variant="outlined"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default MunicipalitySearch;
